var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordsDisableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 20,
    rx: 3,
    fill: "#FFAB2D44"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 16H4V14.4286H11.3333V16ZM15 12.8571H4V11.2857H15V12.8571ZM11.3333 9.71429H4V8.14286H11.3333V9.71429ZM15 6.57143H4V5H15V6.57143Z",
    fill: "#382A2B44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordsDisableIcon);
export default __webpack_public_path__ + "static/media/records-disable-icon.80c76ea16ba10c9f4f1c89e90d195a5f.svg";
export { ForwardRef as ReactComponent };